/* eslint-disable radix */
import React from 'react'
import PropTypes from 'prop-types'
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md'
import { formatToBR } from '../../../utils/date'
import * as formatters from '../../../utils/formats'
import BoxRounded from '../BoxRounded/BoxRounded'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './indicatorManagerial.module.scss'

const IndicatorManagerial = (props) => {
  const {
    title,
    updatedAt,
    current,
    previous,
    minimum,
    periodicityName,
    seeMoreClick,
    formatId,
    margin,
    height,
    width
  } = props

  const newValues = {
    valueMinimum: formatters.formatIndicatorsValueForType(minimum, formatId),
    valuePenult: formatters.formatIndicatorsValueForType(previous, formatId),
    value: formatters.formatIndicatorsValueForType(current, formatId)
  }

  const _minimum = newValues.valueMinimum
  const penult = newValues.valuePenult
  const actual = newValues.value

  return (
    <BoxRounded margin={margin} height={height} width={width}>
      <Flex column>
        <Flex justifyContent="space-between" alignItems="flex-start">
          <Flex column>
            <Text
              size="md"
              bold
              color="gray"
              variation="dark"
              lineHeight="24px"
              margin="0px 0px 4px 0px"
            >
              {title}
            </Text>
            <Text size="xxs" font="custom" color="gray" lineHeight="18px">
              {`${periodicityName}, ${formatToBR(updatedAt)}`}
            </Text>
          </Flex>
          {seeMoreClick && (
            <button
              type="button"
              className={styles.button}
              onClick={seeMoreClick}
            >
              <Text size="xs" color="gray" font="custom" lineHeight="20px">
                ver mais
              </Text>
            </button>
          )}
        </Flex>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          margin="14px 0px 0px 0px"
        >
          <Text
            font="custom"
            size="sm"
            color="gray"
            variation="dark"
            lineHeight="30px"
            fontWeight="400"
            margin="0px 0px 8px 0px"
          >
            Atual
          </Text>
          {current >= previous && (
            <Flex alignItems="center">
              {!!actual.prefix && (
                <Text
                  color="quaternary"
                  variation="dark"
                  size="sm"
                  font="custom"
                  fontWeight="400"
                >
                  {actual.prefix}
                </Text>
              )}
              <Text
                color="quaternary"
                variation="dark"
                size="sm"
                font="custom"
                fontWeight="400"
              >
                {actual.formatted || '0'}
              </Text>
              {!!actual.sufix && (
                <Text
                  color="quaternary"
                  variation="dark"
                  size="sm"
                  font="custom"
                  fontWeight="400"
                >
                  {actual.sufix}
                </Text>
              )}
              <MdKeyboardArrowUp color="#3CAB3A" />
            </Flex>
          )}

          {current < previous && (
            <Flex alignItems="center">
              {!!actual.prefix && (
                <Text color="error" size="sm" font="custom" fontWeight="400">
                  {actual.prefix}
                </Text>
              )}
              <Text color="error" size="sm" font="custom" fontWeight="400">
                {actual.formatted || '0'}
              </Text>
              {!!actual.sufix && (
                <Text color="error" size="sm" font="custom" fontWeight="400">
                  {actual.sufix}
                </Text>
              )}
              <MdKeyboardArrowDown color="#FF3225" />
            </Flex>
          )}
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Text
            font="custom"
            size="xs"
            color="gray"
            fontWeight="400"
            lineHeight="20px"
            margin="0px 0px 8px 0px"
          >
            Mês anterior
          </Text>
          <Flex alignItems="center">
            {!!penult.prefix && (
              <Text
                color="gray"
                variation="light"
                size="xs"
                font="custom"
                fontWeight="400"
                lineHeight="20px"
              >
                {penult.prefix}
              </Text>
            )}

            <Text
              color="gray"
              variation="light"
              size="xs"
              font="custom"
              fontWeight="400"
              lineHeight="20px"
            >
              {penult.formatted || '0'}
            </Text>

            {!!penult.sufix && (
              <Text
                color="gray"
                variation="light"
                size="xs"
                font="custom"
                fontWeight="400"
                lineHeight="20px"
              >
                {penult.sufix}
              </Text>
            )}
          </Flex>
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Text
            font="custom"
            size="xs"
            color="gray"
            fontWeight="400"
            lineHeight="20px"
            margin="0px 0px 8px 0px"
          >
            Ref. mínimo
          </Text>
          <Flex alignItems="center">
            {!!_minimum.prefix && (
              <Text
                font="custom"
                size="xs"
                color="gray"
                variation="dark"
                fontWeight="400"
                lineHeight="20px"
              >
                {_minimum.prefix}
              </Text>
            )}
            <Text
              font="custom"
              size="xs"
              color="gray"
              variation="dark"
              fontWeight="400"
              lineHeight="20px"
            >
              {_minimum.formatted || '0'}
            </Text>
            {!!_minimum.sufix && (
              <Text
                font="custom"
                size="xs"
                color="gray"
                variation="dark"
                fontWeight="400"
                lineHeight="20px"
              >
                {_minimum.sufix}
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>
    </BoxRounded>
  )
}

IndicatorManagerial.defaultProps = {
  seeMoreClick: null,
  margin: '0px',
  previous: null,
  height: '220px',
  width: '348px'
}

IndicatorManagerial.propTypes = {
  title: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  current: PropTypes.string.isRequired,
  previous: PropTypes.string,
  minimum: PropTypes.string.isRequired,
  formatId: PropTypes.number.isRequired,
  periodicityName: PropTypes.string.isRequired,
  seeMoreClick: PropTypes.func,
  margin: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
}

export default IndicatorManagerial
